import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../shared/material/material.module';
import {CountryGuidesComponent} from './country-guides.component';
import {IwgcommonModule} from '../iwgcommon/iwgcommon.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {AppRoutingModule} from '../app-routing.module';
import {UserService} from '../shared/services/user.service';
import {FormsModule} from '@angular/forms';
import {CountryGuideComponent} from './country-guide/country-guide.component';
import {CountryGuideDetailComponent} from './country-guide-detail/country-guide-detail.component';
import {CountryGuideService} from '../shared/services/countryGuide.service';


@NgModule({
    declarations: [
        CountryGuidesComponent,
        // CountryGuideComponent,
        CountryGuideDetailComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        IwgcommonModule,
        FlexLayoutModule,
        AppRoutingModule,
        FormsModule,
    ],
    providers: [UserService, CountryGuideService],
    exports: [
        // CountryGuideComponent
    ]
})
export class CountryGuidesModule {
}
